import React, { PropsWithChildren } from "react";
import { Button } from "@/components/ui/button";
import { ListFilter, X } from "lucide-react";
import { useToggle } from "@/hooks/useToggle";

export const SettlementFiltersBar: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { value: showFilters, handleToggle } = useToggle(false);

  if (!showFilters)
    return (
      <Button
        variant="icon-text"
        onClick={handleToggle}
        className="gap-2 min-h-8 h-8 py-1 border border-slate-200 text-foreground text-sm font-medium shadow-xs"
      >
        <ListFilter className="size-4" />
        Filters
      </Button>
    );

  return (
    <div className="flex flex-row items-center gap-x-2 h-full">
      {children}
      <Button
        variant="icon-text"
        onClick={handleToggle}
        className="gap-2 min-h-8 h-8 py-1 border border-slate-200 text-red-500 text-sm font-medium shadow-xs"
      >
        <X className="size-4" />
        Cancel
      </Button>
    </div>
  );
};
